import { useMediaQuery } from 'react-responsive';
import { MD, LG } from '../util';

export interface DeviceInfo {
    isPhone: boolean;
    isMedium: boolean;
    isDesktop: boolean;
}

export const useDevice = (): DeviceInfo => {
    const isPhone = useMediaQuery({ maxWidth: MD - 0.1 });
    const isMedium = useMediaQuery({ minWidth: MD });
    const isDesktop = useMediaQuery({ minWidth: LG });

    return {
        isPhone,
        isMedium,
        isDesktop
    };
};

export default useDevice;
